document.addEventListener("DOMContentLoaded", () => {
  const SHOPIFY_DISCOUNT = 0.1;
  //  capturing the price element
  const priceElements = document.querySelectorAll(
    '[data-instant-dynamic-content-source="PRICE"]'
  );

  function truncateDiscount(value, decimals = 2) {
    const factor = Math.pow(10, decimals);
    return Math.floor(value * factor) / factor;
  }

  if (priceElements.length === 0) return;

  priceElements.forEach((priceElem) => {
    const variant = JSON.parse(priceElem.getAttribute("data-variant"));
    const sellingPlan = variant.selling_plan_allocations[0];
    if (!sellingPlan?.price) return;

    const price = sellingPlan.price / 100;
    const priceDiscounted = (
      price - truncateDiscount(price * SHOPIFY_DISCOUNT)
    ).toFixed(2);

    priceElem.classList.add("collection-main-price");

    // Check if the discounted price span already exists
    const existingDiscount = priceElem.parentNode.querySelector(
      ".product-price-discounted"
    );
    if (existingDiscount) return; // Skip if already inserted

    // Create a new discounted price span
    const discountPriceElem = document.createElement("span");
    discountPriceElem.textContent = `$${priceDiscounted}`;
    discountPriceElem.classList.add("collection-price-discounted");

    const originalPriceContent = priceElem.textContent.trim();
    // empty it up for new data
    priceElem.innerHTML = "";
    const originalPriceElem = document.createElement("span");
    originalPriceElem.textContent = originalPriceContent;
    originalPriceElem.classList.add("compare-at-price");

    // Insert it before the original price

    priceElem.appendChild(discountPriceElem);
    priceElem.appendChild(originalPriceElem);
  });
});
